import { render, staticRenderFns } from "./SegmentsUpdate.vue?vue&type=template&id=74bb1a0d&scoped=true"
import script from "./SegmentsUpdate.vue?vue&type=script&lang=ts"
export * from "./SegmentsUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb1a0d",
  null
  
)

export default component.exports